import request from '../../../request/request';

const getManagedApplyList = () => {
  return request({
    url: `/api/group-applies?approver`,
    method: 'GET'
  });
};

const approveApply = ({ applyId }) => {
  return request({
    url: `/api/group-applies/${applyId}/approve`,
    method: 'POST'
  });
};

const rejectApply = ({ applyId }) => {
  return request({
    url: `/api/group-applies/${applyId}/reject`,
    method: 'POST',
    data: {}
  });
};

export { getManagedApplyList, approveApply, rejectApply };
